import styled from "styled-components";

const Error = styled.div`
  font-size: 10px;
  margin: 5px 0 0 10px;
  color: #A4262C;
  width: 276px;
`

export default Error
